<div class="flex-row flex-space-between">
  <div class="flex-col-gap">
    <div *ngIf="contribution !== 'transfer_only'">
      <p>{{ depositThisYear | translateNumber: language:currency }}</p>
      <small>{{ 'performance.tabs.deposits.currentYear' | translate }}</small>
    </div>
    <div *ngIf="contribution !== 'transfer_only'">
      <p>{{ getPossibleDeposit() | translateNumber: language:currency }}</p>
      <small>{{ 'performance.tabs.deposits.stillPossible' | translate }}</small>
    </div>
    <div>
      <p>{{ totalInvestment | translateNumber: language:currency }}</p>
      <small>{{ 'performance.tabs.deposits.total' | translate }}</small>
    </div>
  </div>
  <div class="ui-button-group">
    <button
      *ngIf="contribution !== 'transfer_only'"
      [routerLink]="'/adjust-investment'"
      [queryParams]="{ tab: 'savingsPlan' }"
      class="ui-button"
    >
      {{ 'performance.tabs.deposits.CTADeposit' | translate }}
    </button>
    <button routerLink="/adjust-investment" [queryParams]="{ tab: 'transfer3A' }" class="ui-button secondary">
      {{ 'performance.tabs.deposits.CTATransfer' | translate }}
    </button>
  </div>
</div>
<div class="line"></div>
